import React, { Component } from 'react';
import './NavBar2.scss';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
 } from 'reactstrap';


export default class Header extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      fixed: true
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
        <Navbar id="navbar" light expand="md" className="navbar-dark">
          <NavbarBrand href="#"><strong>ALEXANDRE PROVOST</strong></NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="">Accueil</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#AboutUs">Qui suis-je ?</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#skills">Compétences</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#projects">Projets</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#recommandations1">Recommandations</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#contact2">Contact</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
    );
  }
}